<template functional>
    <b-tag :type="$options.getType(props)">{{$options.getTitle(props)}}</b-tag>
</template>

<script>
export default {
  name: 'DatasetCellCustom1',
  props: {
    row: { type: Object, default: () => ({}) },
    columns: { type: Object, default: () => ({}) },
    value: {
      type: [String, Number, Boolean, Array, Object],
      default: () => null,
    },
  },
  getType: (props) => {
      switch(props.row.status){
        case 'done':
            return 'is-success';
            break;
        case 'onreview':
            return 'is-warning';
            break;
        case 'rejected':
            return 'is-danger';
            break;
        case 'canceled':
            return 'is-danger';
            break;
        case 'inprogress': 
            return 'is-primary';
            break;
        default:
            return '';
      }
  },
  getTitle: (props) => {
      switch(props.row.status){
        case 'done':
            return 'Done';
            break;
        case 'onreview':
            return 'On Review';
            break;
        case 'rejected':
            return 'Rejected';
            break;
        case 'canceled':
            return 'Canceled';
            break;
        case 'inprogress': 
            return 'In Progress';
            break;
        default:
            return '';
      }
  }
}
</script>
<style scoped>
    .state-red{
        color: red;
    }
    .state-yellow{
        color: darkorange;
    }
    .state-green{
        color: darkgreen;
    }
</style>